import React from 'react';
import { Link } from 'react-router-dom';
import { FaBookOpen, FaFileAlt, FaCheckCircle, FaGavel, FaQuestionCircle, FaEnvelope, FaStar } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

function Resources() {
  return (
    <div className="resources-page">
      <Helmet>
        <title>Resources - darsgah-e-ahlebait</title>
        <meta name="description" content="Access helpful resources and guides for researchers and authors." />
      </Helmet>
      <div className="container">
        <h2 className="mb-4 text-center fw-bold">Resources</h2>
        <div className="row g-4 mb-4">
          <div className="col-md-6">
            <div className="card shadow-sm h-100 border-0">
              <div className="card-body">
                <h4 className="fw-bold text-primary mb-2"><FaBookOpen className="me-2" />Open Access Journals</h4>
                <p>Explore our peer-reviewed, open access journals dedicated to advancing knowledge in science and the intersection of faith:</p>
                <ul>
                  <li><a href="/jbs">Journal of Biotechnological Sciences (JBS)</a> – Cutting-edge research in biotechnology and life sciences.</li>
                  <li><a href="/jns">Journal of Natural Sciences (JNS)</a> – Original research in physics, chemistry, mathematics, and more.</li>
                  <li><a href="/jis">Journal of Islam and Science (JIS)</a> – Scholarship at the intersection of Islamic thought and scientific inquiry.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card shadow-sm h-100 border-0 bg-warning bg-opacity-10">
              <div className="card-body">
                <h4 className="fw-bold text-warning mb-2"><FaStar className="me-2" />Featured Resource</h4>
                <p>Download our comprehensive <Link to="/author-handbook">Author Handbook</Link> for step-by-step guidance on preparing, submitting, and revising your manuscript. Includes checklists, sample cover letters, and more!</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-4 mb-4">
          <div className="col-md-6">
            <div className="card shadow-sm h-100 border-0">
              <div className="card-body">
                <h4 className="fw-bold text-success mb-2"><FaCheckCircle className="me-2" />Submission Guidelines</h4>
                <ul>
                  <li>Manuscripts must be original, unpublished, and not under consideration elsewhere.</li>
                  <li>Follow the provided <b>author template</b> for formatting.</li>
                  <li>Include a structured abstract, keywords, and references.</li>
                  <li>All submissions are checked for plagiarism and ethical compliance.</li>
                  <li>For detailed instructions, see our <Link to="/submission-guidelines">Submission Guidelines</Link> page.</li>
                </ul>
                <div className="alert alert-info mt-3">Tip: Double-check your references and figures before submitting!</div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card shadow-sm h-100 border-0">
              <div className="card-body">
                <h4 className="fw-bold text-info mb-2"><FaFileAlt className="me-2" />Author Templates & Forms</h4>
                <ul>
                  <li><Link to="/manuscript-template">Manuscript Template (Word)</Link> – Standard format for all journals.</li>
                  <li><Link to="/copyright-transfer">Copyright Transfer Form</Link> – Required for accepted papers.</li>
                  <li><Link to="/conflict-of-interest">Conflict of Interest Disclosure</Link> – Ensure transparency in your research.</li>
                </ul>
                <div className="alert alert-warning mt-3">Tip: Use the latest template version to avoid formatting delays.</div>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-4 mb-4">
          <div className="col-md-6">
            <div className="card shadow-sm h-100 border-0">
              <div className="card-body">
                <h4 className="fw-bold text-secondary mb-2"><FaGavel className="me-2" />Peer Review & Ethics</h4>
                <ul>
                  <li>Double-blind peer review for fairness and quality.</li>
                  <li>COPE-compliant publication ethics and anti-plagiarism policy.</li>
                  <li>Open access: all articles are free to read and share.</li>
                  <li>Authors are encouraged to share data and materials for reproducibility.</li>
                </ul>
                <div className="alert alert-success mt-3">Want to be a reviewer? <a href="mailto:reviewers@darsgah-e-ahlebait.com">Contact us</a> with your CV and expertise.</div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="card shadow-sm h-100 border-0">
              <div className="card-body">
                <h4 className="fw-bold text-danger mb-2"><FaQuestionCircle className="me-2" />FAQ for Authors & Reviewers</h4>
                <ul>
                  <li><b>How do I submit a manuscript?</b> Use the <a href="/submit">online submission portal</a>.</li>
                  <li><b>What is the review timeline?</b> Most reviews are completed within 4-6 weeks.</li>
                  <li><b>Can I suggest reviewers?</b> Yes, during submission.</li>
                  <li><b>How do I access published articles?</b> All articles are free to download.</li>
                  <li><b>Need more help?</b> See our <a href="/help">Help</a> page.</li>
      </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="row g-4 mb-4">
          <div className="col-md-12">
            <div className="card shadow-sm border-0 bg-light">
              <div className="card-body d-flex align-items-center">
                <FaEnvelope className="me-3 text-primary" size={32} />
                <div>
                  <h5 className="fw-bold mb-1">Contact & Support</h5>
                  <p className="mb-0">For further assistance, email <a href="mailto:info@darsgah-e-ahlebait.com">info@darsgah-e-ahlebait.com</a> or visit our <a href="/help">Help</a> page. We’re here to help authors, reviewers, and readers succeed!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Resources; 